import {APIResponse} from '../APITypes';
import { csrfHeaders } from '../csrf';

export default class CourseEventEndpoint {
    static async Create(courseEvent: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/course-event/create',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(courseEvent)
                }
            );
        
        if(!response.ok) {
            throw new Error("Create course-event failed.");
        }
        return await response.json();
    }

    static async GetAvailable(): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/course-event/available',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                }
            );
        
        if(!response.ok) {
            throw new Error("Get available course events failed.");
        }
        return await response.json();
    }

    static async GetUpcoming(): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/course-event/upcoming',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                }
            );
        
        if(!response.ok) {
            throw new Error("Get upcoming course events failed.");
        }
        return await response.json();
    }

    static async Update(courseEvent: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/course-event/update',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(courseEvent)
                }
            );
        
        if(!response.ok) {
            throw new Error("Update course event failed.");
        }
        return await response.json();
    }

    static async Remove(course_event_id: number): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/course-event/remove',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({course_event_id: course_event_id})
                }
            );

        if(!response.ok) {
            throw new Error("Remove course event failed.");
        }
        return await response.json();
    }
}